import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Perks = () => {
  return (
    <div className="Perks p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={10} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Benefits of Working with a Proficient React Native Mobile App Development Agency</h2>
                        <p>Partnering with TekRevol's experienced React Native developers guarantees a flawless digital transformation. We are dedicated to fostering your concepts and ideas, rendering them into result-focused, user-oriented digital experiences. Dive into novelty with our dedicated team.</p>
                    </Col>
                </Row>
                <Row className="h-100 perks-padd">
                <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                    <div className="perks-box">
                        <div className="perks-content">
                            <h4>Robust Technology Integration</h4>
                            <p>Drive your business forward with our React Native mobile app development, utilizing hi-tech technologies for unmatched results.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                 <div className="perks-box">
                        <div className="perks-content">
                            <h4>Adaptable Solutions for Mobile Success</h4>
                            <p>Achieve business goals in Mobile App Development with our tailored and practical approach, customized to meet your exclusive requirements.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                 <div className="perks-box">
                        <div className="perks-content">
                            <h4>Clarity in the Development Journey</h4>
                            <p>Ensure transparency at each development stage with clear procedures, keeping you informed through cutting-edge project management tools for a seamless journey.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                 <div className="perks-box">
                        <div className="perks-content">
                            <h4>Economical Project Investment</h4>
                            <p>Get precise cost estimates for React Native mobile app development with our budget-friendly pricing, ensuring economic effectiveness throughout the project.</p>
                        </div>
                    </div>
                </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Perks